module.exports = __webpack_public_path__ + "static/media/luzDelCielo.eb9113d6.webp";